import { render, staticRenderFns } from "./SessionLogs.vue?vue&type=template&id=38f8fe30&"
import script from "./SessionLogs.vue?vue&type=script&lang=js&"
export * from "./SessionLogs.vue?vue&type=script&lang=js&"
import style0 from "./SessionLogs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports